export enum NumberValidation {
    Ok,
    NotNumber,
    LessThanMin,
    MoreThanMax,
}

/**
 * This function validates if the input is a number within the correct range, taking into consideration the default value.
 */

export function validateNumber(value: string, min: string, max: string): NumberValidation {
    if (value != null) {
        const defaultValue = '';
        const NumericValue = Number(value);

        if (isNaN(NumericValue)) {
            return NumberValidation.NotNumber;
        } else if (value != defaultValue) {
            if (max && Number(max) < NumericValue) {
                return NumberValidation.MoreThanMax;
            } else if (min && Number(min) > NumericValue) {
                return NumberValidation.LessThanMin;
            }
        }
    }
    return NumberValidation.Ok;
}
